import React from 'react';
import {TextField} from '@mui/material';

const PLACEHOLDER = 'Q14EQFGTU678E5I7R';

const VinInput = ({
                      vinMaxLength,
                      vinFieldValue,
                      setVinFieldValue,
                  }) => {

    return (
        <>
            <TextField
                className='vinTextField'
                name={'vin'}
                type={'text'}
                value={vinFieldValue}
                onChange={(event) => {
                    if (typeof event.target?.value === 'string') {
                        setVinFieldValue(event.target?.value?.toUpperCase());
                    } else {
                        setVinFieldValue(event.target?.value);
                    }
                }}
                placeholder={PLACEHOLDER}
                inputProps={{maxLength: vinMaxLength}}
            />
        </>
    );

};

export default VinInput;
